import React, { useState, useEffect } from "react";
import ResumeHoc from "../../Components/Hoc/ResumeHoc";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "../../Components/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { SKILLS } from "../../Redux/ResumeReducer/ResumeTypes";
import { getCandidateProfileById, getUserById, view_resume } from "../../Api/apiService";
import "./Skills.css";
import { toast } from "react-toastify";

import LayoutHOC from "../../Components/Hoc/ResumeHoc";
import ContainerWrapper from "../../Components/ContainerWrapper/container-wrapper";
import { Col, Input, Row, Tag } from "antd";
import ResumeSidebar from "../../Components/Sidebar/Resume-Sidebar";
import CreateResumeWrapper from "./components/Create-Resume-Wrapper";
import CustomizeButton from "../../Components/Button/Customize-Button";
import InputWrapper from "../../Components/Input/Input-Wrapper";
import { Plus } from "lucide-react";
import CustomInput from "../../Components/Input/Custom-Input";
import { selectProfile } from "../../Redux/ResumeReducer/ResumeAction";

function Skills() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  // safe-profileData selector
  const profileData = useSelector((state) => state.resume.profileData || {});
  const technicalSkillsFromStore = profileData.technicalSkills || {};

  // local states seeded from store (will be overridden by fetch if profile loads)
  const [technology, setTechnology] = useState(technicalSkillsFromStore.technology || []);
  const [programmingLanguage, setProgrammingLanguage] = useState(technicalSkillsFromStore.programming || []);
  const [tools, setTools] = useState(technicalSkillsFromStore.tools || []);

  const profileId = new URLSearchParams(location.search).get("profileId");
  const candidateUserId = new URLSearchParams(location.search).get("candidateProfileId");

  const [inputTechnologyValue, setInputTechnologyValue] = useState("");
  const [inputProgrammingLanguageValue, setInputProgrammingLanguageValue] = useState("");
  const [inputToolsValue, setInputToolsValue] = useState("");
    const [resumeTitle, setResumeTitle] = useState("");

  const user = JSON.parse(localStorage.getItem("auth")) || { userId: "" };
  const candidateId = localStorage.getItem("profileId") || "";
  const employeeId = localStorage.getItem("employeeId") || "";
  const role = localStorage.getItem("selectedRole") || "";
  const resume = useSelector((state) => state.resume);
  const selectedProfile = useSelector((state)=> state.resume.selectedProfile);

  

  const userDet = useSelector((state) => state.auth || {});
  const { userId } = userDet || {};

  // ---------- Helpers ----------
  const syncSkillsToRedux = (techArr, progArr, toolsArr, inputs) => {
    dispatch({
      type: SKILLS,
      payload: {
        technology: techArr,
        programming: progArr,
        tools: toolsArr,
        inputs,
      },
    });
  };

  const addSkill = (type, value) => {
  const v = (value || "").trim();
  if (!v) return;

  if (type === "technology" && !technology.includes(v)) {
    setTechnology([...technology, v]);
    setInputTechnologyValue("");
  } else if (type === "programming" && !programmingLanguage.includes(v)) {
    setProgrammingLanguage([...programmingLanguage, v]);
    setInputProgrammingLanguageValue("");
  } else if (type === "tools" && !tools.includes(v)) {
    setTools([...tools, v]);
    setInputToolsValue("");
  }
};
  const removeSkill = (type, skillToRemove) => {
  if (type === "technology") setTechnology(technology.filter((s) => s !== skillToRemove));
  else if (type === "programming") setProgrammingLanguage(programmingLanguage.filter((s) => s !== skillToRemove));
  else if (type === "tools") setTools(tools.filter((s) => s !== skillToRemove));
};

  // handle enter key
 const handleKeyDown = (e, type) => {
  if (e.key === "Enter") {
    e.preventDefault(); // stop form submission
    if (type === "technology") addSkill("technology", inputTechnologyValue);
    else if (type === "programmingLanguage") addSkill("programming", inputProgrammingLanguageValue);
    else if (type === "tools") addSkill("tools", inputToolsValue);
  }
};

useEffect(() => {
  // Check if we already have skills in Redux
  const hasSkillsInRedux = 
    technicalSkillsFromStore && 
    (technicalSkillsFromStore.technology?.length > 0 || 
     technicalSkillsFromStore.programming?.length > 0 || 
     technicalSkillsFromStore.tools?.length > 0);

  // If Redux has skills, don't fetch from API
  if (hasSkillsInRedux) {
    console.log("Skills found in Redux, skipping API call");
    return;
  }

  const fetchProfile = async () => {
    try {
      if (role === "candidate" && candidateId) {
        console.log("inside candidate role");
        const res = await getCandidateProfileById(candidateId);
        console.log(res, "this is response");
        if (res?.status === 200 || res?.status === 201) {
          const profile = res.data.profileData || {};
          const ts = profile.technicalSkills || {};
          setResumeTitle(res.data.resumeTitle || "");
          setTechnology(ts.technology || []);
          setProgrammingLanguage(ts.programming || []);
          setTools(ts.tools || []);
          dispatch({ type: "UPDATE_PROFILE_DATA", payload: profile });
        }
      }
    } catch (err) {
      console.error("Error fetching skills/profile:", err);
    }
  };

  fetchProfile();
}, [role, candidateId, employeeId, user.userId]); // Remove dispatch from deps

// Also update the first useEffect to set state immediately
useEffect(() => {
  if (technicalSkillsFromStore && Object.keys(technicalSkillsFromStore).length > 0) {
    console.log("Setting skills from Redux:", technicalSkillsFromStore);
    setTechnology(technicalSkillsFromStore.technology || []);
    setProgrammingLanguage(technicalSkillsFromStore.programming || []);
    setTools(technicalSkillsFromStore.tools || []);

    if (technicalSkillsFromStore.inputs) {
      setInputTechnologyValue(technicalSkillsFromStore.inputs.technology || "");
      setInputProgrammingLanguageValue(technicalSkillsFromStore.inputs.programming || "");
      setInputToolsValue(technicalSkillsFromStore.inputs.tools || "");
    }
  }
}, [technicalSkillsFromStore]);

useEffect(() => {
  if (selectedProfile?.profileData?.technicalSkills) {
    console.log("Setting skills from selectedProfile:", selectedProfile.profileData.technicalSkills);
    setTechnology(selectedProfile.profileData.technicalSkills.technology || []);
    setProgrammingLanguage(selectedProfile.profileData.technicalSkills.programming || []);
    setTools(selectedProfile.profileData.technicalSkills.tools || []);
  }
}, [selectedProfile]);

  const handlePrevClick = () => {
    if (role === "employee") {
      navigate(profileId ? `/professionalExperience?profileId=${profileId}` : "/professionalExperience");
    } else if (role === "candidate") {
      navigate(`/professionalExperience?candidateProfileId=${candidateUserId}`);
    } else {
      navigate(profileId ? `/professionalExperience?profileId=${profileId}` : "/professionalExperience");
    }
  };


  const handleNextClick = () => {

     const skillsPayload = {
    technology,
    programming: programmingLanguage,
    tools,
  };
  dispatch({
    type: SKILLS,
    payload: skillsPayload,
  });

   if (selectedProfile) {
    dispatch(selectProfile({
      ...selectedProfile,
      profileData: {
        ...selectedProfile.profileData,
        technicalSkills: skillsPayload,
      },
    }));
  }

  if (role === "employee") {
    navigate(profileId ? `/professionalSummary?profileId=${profileId}` : "/professionalSummary");
  } else if (role === "candidate") {
    navigate(candidateId ? `/professionalSummary?candidateProfileId=${candidateId}` : "/professionalSummary");
  } else {
    navigate(profileId ? `/professionalSummary?profileId=${profileId}` : "/professionalSummary");
  }
};

  const handleCancel = () => {
      navigate(user?.role === "ROLE_HR"  ? "/dashboardHr" : "/dashboard");
  }

  // ---------- render ----------
  return (
    <>
      <ContainerWrapper breadcrumbItems={["Resume Builder", "Skills"]}>
        <Row gutter={[20, 20]}>
          <Col span={6}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div>
                <ResumeSidebar title={resumeTitle||selectedProfile?.jobTitle || "Resume Title"} />
              </div>
            </div>
          </Col>
          <Col span={18}>
            <CreateResumeWrapper title={"Skills"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  justifyContent: "space-between",
                }}
              >
                <Row
                  style={{
                    borderRadius: "10px",
                    padding: "16px",
                    border: "1px solid #E8E8E8",
                    marginBottom: "12px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <InputWrapper label={"Technology"}>
                    <div
                      style={{
                        display: "flex",
                        height: "64px",
                        borderRadius: "10px",
                        border: "1px solid #E8E8E8",
                        justifyContent: "center",
                        padding: "12px 16px",
                        alignItems: "center",
                      }}
                    >
                      {technology.map((skill, index) => (
                        <Tag
                          key={index}
                          closable
                          onClose={(e) => {
                            e.preventDefault();
                            removeSkill("technology", skill);
                          }}
                          style={{
                            padding: "8px 16px",
                            fontSize: "16px",
                            borderRadius: "10px",
                            background: "#FDEDEF",
                            border: "1px solid #910E11",
                            color: "#910E11",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {skill}
                        </Tag>
                      ))}

                      {/* Input field */}
                      <CustomInput
                        style={{
                          height: "60px",
                          border: "none",
                        }}
                       
                        value={inputTechnologyValue}
                        onChange={(e) => {
                          setInputTechnologyValue(e.target.value);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, "technology")}
                      />
                    </div>
                  </InputWrapper>
                  <InputWrapper label={"Programming Languages"}>
                    <div
                      style={{
                        display: "flex",
                        height: "64px",
                        borderRadius: "10px",
                        border: "1px solid #E8E8E8",
                        justifyContent: "center",
                        padding: "12px 16px",
                        alignItems: "center",
                      }}
                    >
                      {/* Existing tags */}
                      {programmingLanguage.map((skill, index) => (
                        <Tag
                          key={index}
                          closable
                          onClose={(e) => {
                            e.preventDefault();
                            removeSkill("programming", skill);
                          }}
                          style={{
                            padding: "8px 16px",
                            fontSize: "16px",
                            borderRadius: "10px",
                            background: "#FDEDEF",
                            border: "1px solid #910E11",
                            color: "#910E11",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {skill}
                        </Tag>
                      ))}

                      {/* Input field */}
                      <CustomInput
                        style={{
                          height: "60px",
                          border: "none",
                        }}
                   
                        value={inputProgrammingLanguageValue}
                        onChange={(e) => {
                          setInputProgrammingLanguageValue(e.target.value);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, "programmingLanguage")}
                      />
                    </div>
                  </InputWrapper>
                  <InputWrapper label={"Tools"}>
                    <div
                      style={{
                        display: "flex",
                        height: "64px",
                        borderRadius: "10px",
                        border: "1px solid #E8E8E8",
                        justifyContent: "center",
                        padding: "12px 16px",
                        alignItems: "center",
                      }}
                    >
                      {/* Existing tags */}
                      {tools.map((skill, index) => (
                        <Tag
                          key={index}
                          closable
                          onClose={(e) => {
                            e.preventDefault();
                            removeSkill("tools", skill);
                          }}
                          style={{
                            padding: "8px 16px",
                            fontSize: "16px",
                            borderRadius: "10px",
                            background: "#FDEDEF",
                            border: "1px solid #910E11",
                            color: "#910E11",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {skill}
                        </Tag>
                      ))}

                      {/* Input field */}
                      <CustomInput
                        style={{
                          height: "60px",
                          border: "none",
                        }}
                     
                        value={inputToolsValue}
                        onChange={(e) => {
                          setInputToolsValue(e.target.value);
                        }}
                        onKeyDown={(e) => handleKeyDown(e, "tools")}
                      />
                    </div>
                  </InputWrapper>
                </Row>
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  <CustomizeButton onClick={handleNextClick} variant="primary" style={{ width: "14rem" }}>
                    {" "}
                    Save & Next{" "}
                  </CustomizeButton>
                   <CustomizeButton onClick={handlePrevClick} variant="outlined" style={{ width: "14rem" }}>
                    {" "}
                    Previous
                  </CustomizeButton>
                  <CustomizeButton variant="outlined" style={{ width: "14rem" }} onClick={handleCancel}>
                    {" "}
                    Cancel
                  </CustomizeButton>
                </Row>
              </div>
            </CreateResumeWrapper>
          </Col>
        </Row>
      </ContainerWrapper>
    </>
  );
}

export default LayoutHOC(Skills, { withSidebar: true });
